// ============================================================================
// FSA OPENING BALANCE VERIFICATION ENDPOINTS  (ADR-0007)
// ============================================================================
// BASE_PATH matches FsaObVerificationsController ([Route("api/v1/[controller]")]).

import { buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';

const BASE_PATH = '/FsaObVerifications';

export const fsaObVerificationEndpoints = {
  /** GET /api/v1/FsaObVerifications/by-engagement/{engId} — workspace + live comparison */
  workspace: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId`, { engId }),

  /** POST /api/v1/FsaObVerifications/by-engagement/{engId}/upload — client opening TB (multipart) */
  upload: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/upload`, { engId }),

  /** PUT /api/v1/FsaObVerifications/by-engagement/{engId}/annotations */
  annotations: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/annotations`, { engId }),

  /** GET /api/v1/FsaObVerifications/by-engagement/{engId}/pdf — verification report */
  pdf: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/pdf`, { engId }),

  /** GET /api/v1/FsaObVerifications/by-engagement/{engId}/excel — verification workbook */
  excel: (engId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-engagement/:engId/excel`, { engId }),
} as const;

export default fsaObVerificationEndpoints;
